var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavGames(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1275 10.911C9.82117 10.2853 9.42061 9.71038 8.93981 9.20636C8.74246 9.00659 8.58651 8.76978 8.48095 8.50953C8.45657 8.44739 8.43132 8.38642 8.40519 8.32661C8.26335 8.00117 8.20643 7.64503 8.23978 7.29158C8.27314 6.93812 8.39566 6.59893 8.59588 6.30579C8.94677 5.80724 9.12588 5.20796 9.10612 4.59855C9.09249 4.15954 8.97668 3.72977 8.7679 3.34338C8.55912 2.957 8.26312 2.62466 7.90343 2.37278C7.54374 2.1209 7.13028 1.95643 6.69591 1.89244C6.26154 1.82845 5.81824 1.86669 5.40124 2.00415C4.98423 2.1416 4.60503 2.37446 4.29377 2.68423C3.9825 2.994 3.74776 3.37214 3.6082 3.78858C3.46863 4.20502 3.4281 4.64828 3.48981 5.08315C3.55152 5.51801 3.71378 5.93247 3.9637 6.2936C4.16539 6.59307 4.28836 6.93859 4.32123 7.29819C4.3541 7.6578 4.29582 8.01989 4.15177 8.351C4.13087 8.40326 4.1091 8.45552 4.08734 8.50865C3.98242 8.76904 3.82673 9.00592 3.62934 9.20549C2.25971 10.6079 1.35156 13.0633 1.35156 15.8568C1.35156 18.5308 2.18309 20.8931 3.45607 22.3199H9.11569C9.33782 22.0699 9.53987 21.8029 9.71997 21.5211",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32031 7.29346H8.23677",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89844 8.87769H8.65775",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42969 15.1128V16.0352",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23438 15.1128V16.0352",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33594 15.1128V16.0352",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7925 16.7338C21.7925 19.7397 20.8574 22.3955 19.4259 24H13.0697C11.6383 22.3955 10.7031 19.7397 10.7031 16.7338C10.7031 13.5928 11.7245 10.8325 13.2648 9.25677C13.4869 9.0323 13.6622 8.7658 13.7802 8.47283L13.8525 8.29862C14.0146 7.92633 14.0802 7.51914 14.0432 7.11474C14.0062 6.71035 13.8679 6.32182 13.6409 5.98514C13.3122 5.51136 13.1187 4.95696 13.0812 4.38147C13.0437 3.80599 13.1636 3.23115 13.428 2.71868C13.6924 2.20622 14.0914 1.77547 14.5821 1.47271C15.0727 1.16994 15.6365 1.00658 16.213 1.00018C16.7964 0.994014 17.3703 1.14892 17.8714 1.44785C18.3726 1.74679 18.7816 2.17818 19.0536 2.69459C19.3256 3.211 19.4499 3.79244 19.413 4.37497C19.3761 4.9575 19.1793 5.51856 18.8443 5.99647C18.6194 6.32591 18.4818 6.70706 18.4443 7.10422C18.4069 7.50138 18.4708 7.90156 18.6301 8.26727C18.6588 8.33434 18.6875 8.40315 18.7172 8.47283C18.8352 8.7658 19.0104 9.0323 19.2326 9.25677C20.7712 10.8325 21.7925 13.5928 21.7925 16.7338Z",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0391 7.10693H18.4414",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 8.88745H18.9139",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0391 15.8977V16.9342",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4531 15.8977V16.9342",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3203 15.8977V16.9342",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1797 15.8977V16.9342",
    stroke: "#27BDBE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavGames);
export default __webpack_public_path__ + "static/media/nav-games.910d7e41dbf2edbb391aff95993a7992.svg";
export { ForwardRef as ReactComponent };